// Global Error Boundary Component
export { default as ErrorBoundary } from './ErrorBoundary';

// Re-export for convenience
export default {
  ErrorBoundary: require('./ErrorBoundary').default
}; 